import { styled, YStack } from 'tamagui';
import { ScrollView, View } from 'react-native';

export const MapWebPopup = styled(View, {
  flex: 1,
  zIndex: 99,
  display: 'flex',
  position: 'absolute',
  paddingVertical: '$2',
  width: '25rem',
  height: '95%',
  backgroundColor: 'white',
  top: '1rem',
  left: '1rem',
});

export const MapWebPopupContent = styled(ScrollView, {
  paddingHorizontal: '$4',
});

export const MapNativePopup = styled(YStack, {
  position: 'absolute',
  bottom: 60,
  left: '$1',
  right: '$1',
  backgroundColor: 'white',
  paddingVertical: '$2',
  paddingHorizontal: '$3',
  shadowColor: 'black',
  shadowOffset: { width: 0, height: 2 },
  maxHeight: 300,
  elevation: 2,
  variants: {
    bottom: {
      ':number': (value: number) => ({
        bottom: value,
      }),
    },
  } as const,
});
